/* eslint-disable prettier/prettier */
export const labelsMiddlewareModeled = [
  {
    sr_latn: {
      showDetails: 'Prikaži detalje',
      hideDetails: 'Sakrij detalje',
      select_all: 'Izaberi sve',
      consent_changed: 'Promene su sačuvane.',
    },
  },
  {
    ar: {
      youtube_headline: 'تلزم موافقة يوتيوب (قسم الدعاية)! ',
      youtube_description:
        'نحن نقوم بتقديم [محتويات/فيديوهات] من خلال يوتيوب. ولكي يتسنى لك مشاهدة ذلك، تلزم الموافقة على ملفات الكوكيز ومعالجة البيانات من خلال يوتيوب، أيضاً للأغراض الدعائية.',
      youtube_primaryButton: 'قبول',
      youtube_secondaryButton: 'مزيد من المعلومات',
      googlemaps_headline: 'الموافقة على خرائط جوجل (إعلان) مطلوب!',
      googlemaps_description:
        'نحن نقدم [المحتوى] عبر خرائط جوجل. لعرض ملفات تعريف الارتباط هذه ، يلزم الموافقة على ملفات تعريف الارتباط ومعالجة البيانات بواسطة خرائط Google ، أيضًا للأغراض الإعلانية.',
      googlemaps_primaryButton: 'قبول',
      googlemaps_secondaryButton: 'مزيد من المعلومات',
      showDetails: 'عرض التفاصيل',
      hideDetails: 'إخفاء التفاصيل',
    },
  },
  {
    en: {
      youtube_headline: 'YouTube (advertising) consent required!',
      youtube_description:
        'We provide videos via YouTube. To view these, consent is required for cookies and data processing by YouTube, as well as for advertising purposes.',
      youtube_primaryButton: 'Accept',
      youtube_secondaryButton: 'More information',
      googlemaps_headline: 'Google Maps (advertising) consent required!',
      googlemaps_description:
        'We provide content via Google Maps. To view these, consent is required for cookies and data processing by Google Maps, as well as for advertising purposes.',
      googlemaps_primaryButton: 'Accept',
      googlemaps_secondaryButton: 'More information',
      showDetails: 'Show Details',
      hideDetails: 'Hide Details',
      close: 'Close',
      select_all: 'Select all',
      consent_changed: 'Your changes have been saved.',
    },
  },
  {
    de: {
      youtube_headline: 'YouTube (Werbe-)Zustimmung erforderlich!',
      youtube_description:
        'Wir stellen Videos über YouTube bereit. Um diese anzusehen, ist die Zustimmung zu Cookies und Datenverarbeitung durch YouTube, auch zu Werbezwecken, erforderlich.',
      youtube_primaryButton: 'Akzeptieren',
      youtube_secondaryButton: 'Mehr Informationen',
      googlemaps_headline: 'Google Maps (Werbe-)Zustimmung erforderlich!',
      googlemaps_description:
        'Wir stellen Inhalte über Google Maps bereit. Um diese anzusehen, ist die Zustimmung zu Cookies und Datenverarbeitung durch Google Maps, auch zu Werbezwecken, erforderlich.',
      googlemaps_primaryButton: 'Akzeptieren',
      googlemaps_secondaryButton: 'Mehr Informationen',
      showDetails: 'Details einblenden',
      hideDetails: 'Details ausblenden',
      close: 'Schließen',
      select_all: 'Alles auswählen',
      consent_changed: 'Ihre Änderungen wurden gespeichert',
    },
  },
  {
    el: {
      youtube_headline: 'Απαιτείται συναίνεση (για διαφημίσεις) YouTube!',
      youtube_description:
        'Σας προσφέρουμε βίντεο μέσω YouTube. Για να μπορείτε να τα δείτε, απαιτείται η συναίνεση για τα cookie και την επεξεργασία δεδομένων από το YouTube, ακόμη και για διαφημιστικούς σκοπούς.',
      youtube_primaryButton: 'Αποδοχή',
      youtube_secondaryButton: 'Περισσότερες πληροφορίες',
      googlemaps_headline: 'Απαιτείται συναίνεση (για διαφημίσεις) Google Maps!',
      googlemaps_description:
        'Σας προσφέρουμε περιεχόμεναμέσω Google Maps. Για να μπορείτε να τα δείτε, απαιτείται η συναίνεση για τα cookie και την επεξεργασία δεδομένων από το Google Maps, ακόμη και για διαφημιστικούς σκοπούς.',
      googlemaps_primaryButton: 'Αποδοχή',
      googlemaps_secondaryButton: 'Περισσότερες πληροφορίες',
      showDetails: 'Εμφάνιση λεπτομερειών',
      hideDetails: 'κλείσιμο λεπτομερειών',
    },
  },
  {
    fr: {
      youtube_headline: 'Consentement (à la publicité) requis pour YouTube!',
      youtube_description:
        'Nous proposons des vidéos par le biais de YouTube. Pour visionner celles-ci, il est nécessaire d\'autoriser les cookies et le traitement de données par YouTube, y compris à des fins publicitaires.',
      youtube_primaryButton: 'Accepter',
      youtube_secondaryButton: 'Plus d\'informations',
      googlemaps_headline: 'Consentement (à la publicité) requis pour Google Maps!',
      googlemaps_description:
        'Nous proposons des contenus par le biais de Google Maps. Pour visionner celles-ci, il est nécessaire d\'autoriser les cookies et le traitement de données par Google Maps, y compris à des fins publicitaires.',
      googlemaps_primaryButton: 'Accepter',
      googlemaps_secondaryButton: 'Plus d\'informations',
      showDetails: 'Afficher les détails',
      hideDetails: 'Masquer les détails',
      select_all: 'Sélectionner tout',
      consent_changed: 'Vos modifications ont été enregistrées',
    },
  },
  {
    nl: {
      youtube_headline: 'YouTube (reclame-)toestemming vereist!',
      youtube_description:
        'We stellen video\'s via YouTube beschikbaar. Om deze te bekijken, is instemming met cookies en toestemming voor de gegevensverwerking door YouTube, ook voor reclamedoeleinden, vereist.',
      youtube_primaryButton: 'Akkoord',
      youtube_secondaryButton: 'Meer informatie',
      googlemaps_headline: 'Google Maps (reclame-)toestemming vereist!',
      googlemaps_description:
        'We stellen content via Google Maps beschikbaar. Om deze te bekijken, is instemming met cookies en toestemming voor de gegevensverwerking door Google Maps, ook voor reclamedoeleinden, vereist.',
      googlemaps_primaryButton: 'Akkoord',
      googlemaps_secondaryButton: 'Meer informatie',
      showDetails: 'Details weergeven',
      hideDetails: 'Details verbergen',
    },
  },
  {
    sr: {
      youtube_headline: 'Potrebna saglasnost Jutjuba (oglašavanja) !',
      youtube_description:
        'Obezbeđujemo video zapise putem YouTube-a. Da biste ih prikazali, potrebno je da pristanete na kolačiće i obradu podataka od strane YouTube-a, uključujući i u svrhe oglašavanja.',
      youtube_primaryButton: 'Prihvati',
      youtube_secondaryButton: 'Za više informacija',
    },
  },
];
